import { c as _c } from "react-compiler-runtime";
import classNames from "clsx";
import * as React from "react";
import { Button as AriaButton, Link as AriaLink } from "react-aria-components";
import { icon } from "../icon.css.js";
import { button, buttonContent, buttonText, destructiveButton, disabledButton, loadingButtonContent } from "./Button.css.js";
import { PlainSpinner } from "./Spinner.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function populateDefaults(props) {
  const {
    hierarchy = "primary",
    size = "m",
    destructive = false,
    loading = false,
    ...rest
  } = props;
  return {
    hierarchy,
    size,
    destructive,
    loading,
    ...rest
  };
}
export const Button = t0 => {
  const $ = _c(33);
  let children;
  let unsafeProps;
  if ($[0] !== t0) {
    ({
      children,
      ...unsafeProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = unsafeProps;
  } else {
    children = $[1];
    unsafeProps = $[2];
  }
  let buttonRef;
  let destructive;
  let disabled;
  let hierarchy;
  let loading;
  let onPress;
  let props;
  let size;
  let t1;
  let type;
  let wrapperClassname;
  if ($[3] !== children || $[4] !== unsafeProps) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      props = populateDefaults(unsafeProps);
      const {
        hierarchy: t2,
        size: t3,
        destructive: t4,
        loading: t5,
        disabled: t6,
        variant
      } = props;
      hierarchy = t2;
      size = t3;
      destructive = t4;
      loading = t5;
      disabled = t6;
      if (props.variant === "link") {
        const {
          anchorRef,
          ...rest
        } = props;
        t1 = /*#__PURE__*/_jsx(Link, {
          ref: anchorRef,
          ...rest,
          children: children
        });
        break bb0;
      }
      wrapperClassname = classNames(button({
        size,
        hierarchy,
        iconOnly: variant === "iconOnly",
        loading
      }), disabled === true ? disabledButton({
        hierarchy
      }) : destructive === true && destructiveButton({
        hierarchy
      }));
      ({
        type,
        onPress,
        buttonRef
      } = props);
      if (variant === "iconOnly" && loading === true) {
        t1 = /*#__PURE__*/_jsx(AriaButton, {
          className: wrapperClassname,
          type: type,
          onPress: onPress,
          ref: buttonRef,
          isDisabled: disabled,
          isPending: true,
          children: /*#__PURE__*/_jsx(Spinner, {
            size: size,
            hierarchy: hierarchy,
            destructive: destructive
          })
        });
        break bb0;
      }
      if (variant === "iconOnly") {
        const Icon = props.leadingIcon;
        t1 = /*#__PURE__*/_jsx(AriaButton, {
          className: wrapperClassname,
          type: type,
          onPress: onPress,
          isDisabled: disabled,
          ref: buttonRef,
          children: /*#__PURE__*/_jsx(Icon, {
            className: icon({
              size
            })
          })
        });
        break bb0;
      }
    }
    $[3] = children;
    $[4] = unsafeProps;
    $[5] = buttonRef;
    $[6] = destructive;
    $[7] = disabled;
    $[8] = hierarchy;
    $[9] = loading;
    $[10] = onPress;
    $[11] = props;
    $[12] = size;
    $[13] = t1;
    $[14] = type;
    $[15] = wrapperClassname;
  } else {
    buttonRef = $[5];
    destructive = $[6];
    disabled = $[7];
    hierarchy = $[8];
    loading = $[9];
    onPress = $[10];
    props = $[11];
    size = $[12];
    t1 = $[13];
    type = $[14];
    wrapperClassname = $[15];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[16] !== children || $[17] !== props) {
    t2 = /*#__PURE__*/_jsx(ButtonContent, {
      ...props,
      children: children
    });
    $[16] = children;
    $[17] = props;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== destructive || $[20] !== hierarchy || $[21] !== loading || $[22] !== size) {
    t3 = loading === true && /*#__PURE__*/_jsx(Spinner, {
      size: size,
      hierarchy: hierarchy,
      destructive: destructive
    });
    $[19] = destructive;
    $[20] = hierarchy;
    $[21] = loading;
    $[22] = size;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== buttonRef || $[25] !== disabled || $[26] !== loading || $[27] !== onPress || $[28] !== t2 || $[29] !== t3 || $[30] !== type || $[31] !== wrapperClassname) {
    t4 = /*#__PURE__*/_jsxs(AriaButton, {
      className: wrapperClassname,
      type: type,
      onPress: onPress,
      ref: buttonRef,
      isDisabled: disabled,
      isPending: loading,
      children: [t2, t3]
    });
    $[24] = buttonRef;
    $[25] = disabled;
    $[26] = loading;
    $[27] = onPress;
    $[28] = t2;
    $[29] = t3;
    $[30] = type;
    $[31] = wrapperClassname;
    $[32] = t4;
  } else {
    t4 = $[32];
  }
  return t4;
};
const BaseLink = (t0, ref) => {
  const $ = _c(16);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const {
    hierarchy,
    size,
    disabled
  } = props;
  let t1;
  if ($[3] !== disabled || $[4] !== hierarchy || $[5] !== size) {
    t1 = classNames(button({
      size,
      hierarchy
    }), disabled === true && disabledButton({
      hierarchy
    }));
    $[3] = disabled;
    $[4] = hierarchy;
    $[5] = size;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const wrapperClassname = t1;
  let t2;
  if ($[7] !== children || $[8] !== props) {
    t2 = /*#__PURE__*/_jsx(ButtonContent, {
      ...props,
      children: children
    });
    $[7] = children;
    $[8] = props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== disabled || $[11] !== props || $[12] !== ref || $[13] !== t2 || $[14] !== wrapperClassname) {
    t3 = /*#__PURE__*/_jsx(AriaLink, {
      className: wrapperClassname,
      ref: ref,
      isDisabled: disabled,
      ...props,
      children: t2
    });
    $[10] = disabled;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = wrapperClassname;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
const Link = /*#__PURE__*/React.forwardRef(BaseLink);
function ButtonContent(props) {
  const $ = _c(19);
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = props;
  const {
    size,
    hierarchy,
    destructive,
    loading,
    children
  } = props;
  let t0;
  if ($[0] !== destructive || $[1] !== hierarchy || $[2] !== loading || $[3] !== size) {
    t0 = classNames(buttonContent({
      size
    }), loading === true && loadingButtonContent({
      hierarchy,
      destructive
    }));
    $[0] = destructive;
    $[1] = hierarchy;
    $[2] = loading;
    $[3] = size;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== LeadingIcon || $[6] !== size) {
    t1 = LeadingIcon && /*#__PURE__*/_jsx(LeadingIcon, {
      className: icon({
        size
      })
    });
    $[5] = LeadingIcon;
    $[6] = size;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== size) {
    t2 = children != null && /*#__PURE__*/_jsx("span", {
      className: buttonText({
        size
      }),
      children: children
    });
    $[8] = children;
    $[9] = size;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== TrailingIcon || $[12] !== size) {
    t3 = TrailingIcon && /*#__PURE__*/_jsx(TrailingIcon, {
      className: icon({
        size
      })
    });
    $[11] = TrailingIcon;
    $[12] = size;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t0 || $[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: t0,
      children: [t1, t2, t3]
    });
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
function getSpinnerColor(hierarchy, destructive) {
  if (!hierarchy) {
    return destructive === true ? "destructive" : "white";
  }
  if (destructive === true) {
    switch (hierarchy) {
      case "primary":
        {
          return "white";
        }
      default:
        {
          return "destructive";
        }
    }
  }
  switch (hierarchy) {
    case "primary":
      {
        return "white";
      }
    case "alertError":
      {
        return "destructive";
      }
    case "alertSuccess":
    case "alertWarning":
      {
        return hierarchy;
      }
    case "alertWarningSecondary":
      {
        return "alertWarning";
      }
    default:
      {
        return "royalBlue";
      }
  }
}
const Spinner = t0 => {
  const $ = _c(6);
  const {
    size,
    hierarchy,
    destructive
  } = t0;
  let t1;
  if ($[0] !== destructive || $[1] !== hierarchy) {
    t1 = getSpinnerColor(hierarchy, destructive);
    $[0] = destructive;
    $[1] = hierarchy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== size || $[4] !== t1) {
    t2 = /*#__PURE__*/_jsx(PlainSpinner, {
      size: size,
      color: t1
    });
    $[3] = size;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
//# sourceMappingURL=Button.js.map